/*
 * File: cell-action-separator.ts
 * Created: 2025-12-06 16:24:48
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-06 16:36:16
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { Component, Prop } from "vue-property-decorator";
import CellActionBase from "../../base/cell-action-base";

@Component
export default class CellActionSeparator extends CellActionBase {}
